<template>
  <div class="bg-white rounded-2xl shadow-lg p-6">
    <div class="mb-6">
      <h2 class="text-2xl font-bold text-gray-900 flex items-center gap-3 mb-2">
        <span :style="{ fontSize: '32px' }">{{ typeInfo.emoji }}</span>
        <span>您的主要职业类型：{{ typeInfo.fullName }}</span>
      </h2>
      <p class="text-gray-600 text-lg">深入了解您的职业兴趣特征</p>
    </div>

    <!-- 描述卡片 -->
    <div 
      class="p-6 rounded-xl mb-6 border-2"
      :style="{ 
        background: `linear-gradient(135deg, ${typeInfo.bgColor}, #ffffff)`,
        borderColor: typeInfo.color + '20'
      }"
    >
      <p class="text-base leading-relaxed text-gray-800 mb-4">
        {{ typeInfo.description }}
      </p>
      <p class="text-base leading-relaxed text-gray-800">
        {{ typeInfo.workStyle }}
      </p>
    </div>

    <!-- 性格特质 -->
    <div class="mb-6">
      <h4 class="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <span>💎</span>
        <span>性格特质</span>
      </h4>
      <div class="flex flex-wrap gap-2">
        <span
          v-for="(trait, index) in typeInfo.traits"
          :key="index"
          class="px-4 py-2 rounded-full text-sm font-medium"
          :style="{
            backgroundColor: typeInfo.color + '15',
            color: typeInfo.color,
            border: `1px solid ${typeInfo.color}30`
          }"
        >
          {{ trait }}
        </span>
      </div>
    </div>

    <!-- 核心优势 -->
    <div>
      <h4 class="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <span>⭐</span>
        <span>核心优势</span>
      </h4>
      <ul class="space-y-2">
        <li 
          v-for="(strength, index) in typeInfo.strengths"
          :key="index"
          class="flex items-start gap-3 text-gray-700"
        >
          <span class="text-green-500 mt-1">✓</span>
          <span>{{ strength }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/**
 * 主要职业类型卡片
 * 展示用户的主导Holland类型的详细信息
 */
export default {
  name: 'PrimaryTypeCard',
  props: {
    typeInfo: {
      type: Object,
      required: true
    }
  }
}
</script>

